import { useState, useContext, useEffect } from "react";
import * as rewardsApi from "../../services/ApiServices/ApiService";
import { logTrace } from "../../services/ApiServices/LoggingService";
import UpcomingPromotionModal from "./UpcomingPromotionModal";
import UniversalModal from "../UniversalModal";
import { FeatureFlagContext } from "../../context/FeatureFlagContextProvider";
import "../../styles/UpcomingPromotions.css";
import "@gdk/card-selections/dist/styles/gdk-card-selections.css";
import * as promotionTypes from "../../utils/constants/promotionTypes";
import { trackModalLoad } from "../../services/gtm/gtmTracker";
import { UPCOMING_PROMOTION_MODAL } from "../../services/gtm/pageNames";

const actionTrackId = (action, cardIndex) =>
  cardIndex > 0 ? `${action}-${cardIndex + 1}` : action;

const UpcomingPromotionCard = ({
  id,
  cardTitle,
  promotionDescription,
  daysRemaining,
  index
}) => {
  const incentiveIdList = [id];
  const [modalVisible, setModalVisible] = useState(false);
  const featureFlags = useContext(FeatureFlagContext);
  const [figmaHeaderFlag, setFigmaHeaderFlag] = useState(false);
  const [learnMoreText , setLearnMoreText] = useState("Learn More");

  const Enroll = async () => {
    const handleError = (error) => {
      logTrace(error, "error when calling rewardsApi.Enroll", "Enroll in UpcomingPromotionCard.jsx");
    };
    const handleSuccess = (responseData) => {
      window.location.reload();
    };
    await rewardsApi.Enroll(
      { data: incentiveIdList },
      handleSuccess,
      handleError
    );
  };

  useEffect(() => {
    setFigmaHeaderFlag(featureFlags?.UpdatedHeaderOnHomePageFlag);

    if (figmaHeaderFlag)
    {
      setLearnMoreText("Promotion Information");
    }
    else
    {
      setLearnMoreText("Learn More");
    }

  }, [featureFlags, figmaHeaderFlag]);

  const handleSubmit = async () => {
    Enroll();
  };

  const getClassName = (index) => {
    if (figmaHeaderFlag) {
      switch (index) {
        case 0:
          return "upcoming-campaign-cards-figma";
        default:
          return "upcoming-campaign-cards-figma offset-lg-1";
      }
    }
    else {
      switch (index) {
        case 0:
          return "upcoming-campaign-cards";
        default:
          return "upcoming-campaign-cards offset-lg-1";
      }
    }
  };
  const openPromotionInformation = (event) => {
    event.preventDefault();
    if (!modalVisible) {
      trackModalLoad(UPCOMING_PROMOTION_MODAL);
    }
    setModalVisible(true);
  };

  return (
    <div>
      {(modalVisible && !figmaHeaderFlag) && (
        <UpcomingPromotionModal
          setShow={setModalVisible}
          cardTitle={cardTitle}
          promotionDescription={promotionDescription}
          daysRemaining={daysRemaining}
        />
      )}
      {(modalVisible && figmaHeaderFlag) && (
        <UniversalModal
          setShow={setModalVisible}
          header={cardTitle}
          contentType={promotionTypes.UpcomingPromotion}
          promotionDescription={promotionDescription}
          daysRemaining={daysRemaining}
        />
      )}
      <div
        className={getClassName(index) + " radio-cards-container"}
        id={id}
      >
        {figmaHeaderFlag ? (
          <>
            <h4 className="upcoming-campaign-cards-head card-overflow">
              {cardTitle}
            </h4>
            <span className="counter-text card-overflow">
              {daysRemaining > 0 && (
                <strong>{daysRemaining.toString()} days until start</strong>
              )}
            </span>
            <div className="chips chips-neutral" style={{ marginBottom: "1rem" }}>
              Not Activated
            </div>
          </>
        ) : (
          <>
            <h5 className="upcoming-campaign-cards-head card-overflow">
              {cardTitle}
            </h5>
            <p className="days-left-counter card-overflow">
              {daysRemaining.toString()} days left
            </p>
          </>
        )}
        <p className="card-overflow" style={{ marginBottom: 0 }}>
          {promotionDescription}
        </p>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          className="card-overflow"
          href="#"
          data-trackid={actionTrackId("promotion-information", index)}
          onClick={openPromotionInformation}
        >
          {learnMoreText}
        </a>
        <div style={{ marginTop: "2rem" }} className="btn-center">
          <button
            type="button"
            className="btn btn--secondary btn--full-mobile"
            data-trackid={actionTrackId("activate", index)}
            onClick={() => handleSubmit()}
          >
            <span>Activate</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpcomingPromotionCard;
